import { TreeNode } from 'primeng/api';

export interface ReceitaPrevistoArrecadadoItem {
  codigo: string;
  nome: string;
  nivel: number;
  previsto: number;
  arrecadado: number;
}

export interface ReceitaPrevistoArrecadadoLinha {
  codigo: string;
  nome: string;
  nivel: number;
  receita: string;
  previsto: number;
  arrecadado: number;
}

export function normalizarPeriodo(mesInicial: number, mesFinal: number): { mesInicial: number; mesFinal: number } {
  return mesInicial <= mesFinal
    ? { mesInicial, mesFinal }
    : { mesInicial: mesFinal, mesFinal: mesInicial };
}

export function montarArvoreReceitaPrevistoArrecadado(itens: ReceitaPrevistoArrecadadoItem[]): TreeNode[] {
  const raizes: TreeNode[] = [];
  const pilha: TreeNode[] = [];

  itens.forEach(item => {
    const node: TreeNode = {
      expanded: item.nivel < 1,
      data: {
        codigo: item.codigo,
        nome: item.nome,
        nivel: item.nivel,
        receita: `${item.codigo} - ${item.nome}`,
        previsto: item.previsto,
        arrecadado: item.arrecadado
      },
      children: []
    };

    while (pilha.length && +pilha[pilha.length - 1].data.nivel >= +item.nivel) {
      pilha.pop();
    }

    if (pilha.length) {
      pilha[pilha.length - 1].children.push(node);
    } else {
      raizes.push(node);
    }

    pilha.push(node);
  });

  return raizes;
}

export function obterLinhasVisiveisExportacao(nodes: TreeNode[]): ReceitaPrevistoArrecadadoLinha[] {
  const linhas: ReceitaPrevistoArrecadadoLinha[] = [];

  const visitar = (node: TreeNode, profundidade: number): void => {
    linhas.push({
      ...node.data,
      receita: `${'   '.repeat(profundidade)}${node.data.receita}`
    });

    if (node.expanded && node.children?.length) {
      node.children.forEach(filho => visitar(filho, profundidade + 1));
    }
  };

  nodes.forEach(node => visitar(node, 0));

  return linhas;
}
